/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import HouseManual from './HouseManual'

/**
 * The InlineResponse20033 model module.
 * @module model/InlineResponse20033
 * @version 1.0.0
 */
export default class InlineResponse20033 {
  /**
   * Constructs a new <code>InlineResponse20033</code>.
   * @alias module:model/InlineResponse20033
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20033</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20033} obj Optional instance to populate.
   * @return {module:model/InlineResponse20033} The populated <code>InlineResponse20033</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20033()

      if (data.hasOwnProperty('house_manual')) {
        obj['house_manual'] = HouseManual.constructFromObject(data['house_manual'])
      }
    }
    return obj
  }

  /**
   * @member {module:model/HouseManual} house_manual
   */
  house_manual = undefined
}
